import React from "react";

const QuestionsList = ({
    selectedTopic,
    filteredQuestions,
    questions,
    questionSearchQuery,
    setQuestionSearchQuery,
    loadingQuestions,
    fetchingQuestionId,
    handleViewQuestion,
    onChangeTopic,
    t
}) => {
    return (
        <div className="col-lg-8">
            <div className="admin-card questions-viewer-card glass-panel">
                <div className="card-header-premium header-flex-questions">
                    <div className="header-left-questions">
                        <h4 className="card-title-premium">
                            <i className="fal fa-question-circle card-icon-gradient-blue"></i>
                            <span>{t("QuestionView.questions")}</span>
                        </h4>
                        {selectedTopic && (
                            <div className="topic-indicator-badge">
                                <i className="fal fa-hashtag text-accent-blue"></i>
                                <span>{selectedTopic.TopicName}</span>
                            </div>
                        )}
                    </div>

                    {selectedTopic && questions.length > 0 && (
                        <div className="search-questions-wrapper">
                            <i className="fal fa-filter search-icon-premium"></i>
                            <input
                                type="text"
                                className="form-control search-input-premium"
                                placeholder={t("QuestionView.filterQuestions")}
                                value={questionSearchQuery}
                                onChange={(e) => setQuestionSearchQuery(e.target.value)}
                            />
                            {questionSearchQuery && (
                                <button className="search-clear-btn" onClick={() => setQuestionSearchQuery("")}>
                                    <i className="fal fa-times-circle"></i>
                                </button>
                            )}
                        </div>
                    )}
                </div>

                <div className="questions-list-wrapper-premium">
                    {loadingQuestions ? (
                        <div className="content-loader-premium text-center py-5">
                            <div className="loader-ring loader-ring-large"><div></div><div></div><div></div><div></div></div>
                            <h5 className="mt-4 text-muted">{t("QuestionView.pleaseWait")}</h5>
                        </div>
                    ) : !selectedTopic ? (
                        <div className="empty-questions-state-premium text-center py-5">
                            <div className="illustration-box mb-4">
                                <i className="fal fa-mouse-pointer-click empty-icon-premium animation-bounce"></i>
                            </div>
                            <h3>{t("QuestionView.selectTopicPrompt")}</h3>
                            <p className="text-muted">{t("QuestionView.selectTopicDesc")}</p>
                        </div>
                    ) : filteredQuestions.length === 0 ? (
                        <div className="empty-questions-state-premium text-center py-5">
                            <div className="illustration-box mb-4">
                                <i className="fal fa-search empty-icon-premium"></i>
                            </div>
                            <h3>{questionSearchQuery ? t("QuestionView.noQuestionsMatch") : t("QuestionView.noQuestions")}</h3>
                            <p className="text-muted">
                                {questionSearchQuery
                                    ? t("QuestionView.filterQuestionsTip")
                                    : t("QuestionView.noQuestionsDesc")
                                }
                            </p>
                        </div>
                    ) : (
                        <div className="questions-list-layout">
                            <div className="questions-count-header mb-3">
                                <span>{t("QuestionView.showLabel")} <b>{filteredQuestions.length}</b> {t("QuestionView.ofLabel")} <b>{questions.length}</b> {t("QuestionView.questionsLinkedToTopic")}</span>
                            </div>
                            <div className="questions-grid-premium">
                                {filteredQuestions.map((question, index) => (
                                    <div key={question.QuestionId} className="question-card-premium">
                                        <div className="question-card-inner-flex">
                                            <div className="question-badge-index">
                                                <span>{index + 1}</span>
                                            </div>
                                            <div className="question-card-content">
                                                <p className="question-text-paragraph" dangerouslySetInnerHTML={{ __html: question.QuestionText }} />
                                                <div className="question-card-footer-premium d-flex flex-wrap gap-2 mt-3 align-items-center w-100 border-top pt-2">
                                                    {question.IsRelativeToTopic === true && (
                                                        <span className="badge px-3 py-2 d-inline-flex align-items-center gap-1 text-right" style={{ borderRadius: '8px', fontSize: '0.8rem', fontWeight: '600', backgroundColor: '#d1fae5', color: '#065f46', border: '1px solid #a7f3d0', direction: 'rtl' }}>
                                                            <i className="fal fa-shield-check ml-1"></i>
                                                            <span>{t("QuestionView.general")}</span>
                                                        </span>
                                                    )}
                                                    {question.IsRelativeToTopic === false && (
                                                        <span className="badge px-3 py-2 d-inline-flex align-items-center gap-1 text-right" style={{ borderRadius: '8px', fontSize: '0.8rem', fontWeight: '600', backgroundColor: '#e0f2fe', color: '#0369a1', border: '1px solid #bae6fd', direction: 'rtl' }}>
                                                            <i className="fal fa-book-reader ml-1"></i>
                                                            <span>{t("QuestionView.relativeToText")}</span>
                                                        </span>
                                                    )}
                                                    {(question.IsRelativeToTopic === null || question.IsRelativeToTopic === undefined) && (
                                                        <span className="badge px-3 py-2 d-inline-flex align-items-center gap-1 text-right" style={{ borderRadius: '8px', fontSize: '0.8rem', fontWeight: '600', backgroundColor: '#fef3c7', color: '#92400e', border: '1px solid #fde68a', direction: 'rtl' }}>
                                                            <i className="fal fa-question-circle ml-1"></i>
                                                            <span>{t("QuestionView.unclassified")}</span>
                                                        </span>
                                                    )}
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-primary d-inline-flex align-items-center gap-1 text-decoration-none px-3"
                                                        style={{ borderRadius: '8px', fontWeight: '600' }}
                                                        onClick={() => handleViewQuestion(question)}
                                                        disabled={fetchingQuestionId === question.QuestionId}
                                                    >
                                                        {fetchingQuestionId === question.QuestionId ? (
                                                            <i className="fa-spin fas fa-spinner ml-1"></i>
                                                        ) : (
                                                            <i className="fal fa-eye ml-1"></i>
                                                        )}
                                                        <span>{t("QuestionView.previewQuestion")}</span>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1 text-decoration-none px-3"
                                                        style={{ borderRadius: '8px', fontWeight: '600' }}
                                                        onClick={() => onChangeTopic(question)}
                                                    >
                                                        <i className="fal fa-exchange-alt ml-1"></i>
                                                        <span>{t("QuestionView.changeTopic")}</span>
                                                    </button>
                                                    {question.LessonId && (
                                                        <div className="d-inline-flex flex-wrap gap-2 align-items-center">
                                                            <span className="lesson-label-premium text-muted ml-2 mr-2">
                                                                <i className="fal fa-book-open"></i>  {question.LessonName}:
                                                            </span>
                                                            {(!question.LessonViewType || question.LessonViewType === "Lesson") && (
                                                                <a
                                                                    href={`/LessonView/${question.LessonId}`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="btn btn-xs btn-outline-info d-inline-flex align-items-center gap-1 text-decoration-none px-2 py-1"
                                                                    style={{ borderRadius: '6px', fontSize: '0.8rem', fontWeight: '500' }}
                                                                >
                                                                    <span>{t("QuestionView.lessonView")}</span>
                                                                    <i className="fal fa-external-link-alt mr-1"></i>
                                                                </a>
                                                            )}
                                                            {question.LessonViewType === "Game" && (
                                                                <a
                                                                    href={`/GameView/${question.LessonId}`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="btn btn-xs btn-outline-warning d-inline-flex align-items-center gap-1 text-decoration-none px-2 py-1"
                                                                    style={{ borderRadius: '6px', fontSize: '0.8rem', fontWeight: '500' }}
                                                                >
                                                                    <span>{t("QuestionView.gameView")}</span>
                                                                    <i className="fal fa-gamepad mr-1"></i>
                                                                </a>
                                                            )}
                                                            {question.LessonViewType === "Exam" && (
                                                                <a
                                                                    href={`/ExamView/${question.LessonId}`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="btn btn-xs btn-outline-success d-inline-flex align-items-center gap-1 text-decoration-none px-2 py-1"
                                                                    style={{ borderRadius: '6px', fontSize: '0.8rem', fontWeight: '500' }}
                                                                >
                                                                    <span>{t("QuestionView.examView")}</span>
                                                                    <i className="fal fa-file-signature mr-1"></i>
                                                                </a>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default QuestionsList;
